<template>
  <div class="student-course-performance-detail">
    <div class="score-wrap">
      <template v-if="showDetail">
        <el-popover title="学期成绩"
                    transition="dialog-fade"
                    placement="left"
                    width="450"
                    trigger="hover"
                    popper-class="student-course-performance-detail-popper"
                    :open-delay="200"
                    :disabled="!showDetail"
                    @show="loadDetailScore">
          <div class="detail-main"
               v-loading="loading"
               element-loading-text="数据加载中，请稍等...">
            <DataGrid size="mini"
                      resizable
                      highlight-current-row
                      highlight-hover-row
                      :data="electives">
              <DataGridColumn title="学期"
                              field="semester"
                              align="center"
                              min-width="100"></DataGridColumn>
              <DataGridColumn title="班级"
                              field="clazz"
                              align="center"
                              min-width="120"></DataGridColumn>
              <DataGridColumn title="考核方式"
                              field="examStyle"
                              align="center"
                              min-width="80"></DataGridColumn>
              <DataGridColumn title="成绩"
                              align="center"
                              min-width="80">
                <template #default="{row}">
                  <span :class="row.scoreZh | scoreState(passScore)">{{row.scoreLuru}}</span>
                </template>
              </DataGridColumn>
              <template #empty>
                <span>未查询到学期成绩</span>
              </template>
            </DataGrid>
          </div>
          <span slot="reference"
                class="holder">
            <span :class="['value', scoreState]">{{scoreInput}}</span>
          </span>
        </el-popover>
      </template>
      <template v-else>
        <span :class="['value', scoreState]">{{scoreInput}}</span>
      </template>
    </div>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
export default {
  name: 'StudentCoursePerformanceDetail',
  components: {
    DataGrid,
    DataGridColumn
  },
  props: {
    scoreType: {
      type: String,
      validator (val) {
        return ['scoreCx', 'scoreBx', 'scoreFinal'].includes(val)
      }
    },
    studentId: {
      type: String,
      required: true
    },
    score: {
      type: Object,
      required: true
    },
    passScore: {
      type: Number,
      default: 60
    }
  },
  data () {
    return {
      loading: false,
      electives: null
    }
  },
  filters: {
    scoreState (score, passScore) {
      if (typeof score === 'number') {
        if (score < passScore) {
          return 'is-fail'
        }
      }
    }
  },
  computed: {
    scoreInput () {
      return this.score[`${this.scoreType}Luru`]
    },
    scoreDigit () {
      return this.score[`${this.scoreType}Zh`]
    },
    scoreState () {
      let scoreDigit = this.scoreDigit
      if (typeof scoreDigit === 'number') {
        if (scoreDigit < this.passScore) {
          return 'is-fail'
        }
      }
    },
    showDetail () {
      return this.scoreType === 'scoreFinal'
    }
  },
  methods: {
    loadDetailScore () {
      if (!this.electives && !this.loading) {
        this.loading = true
        this.$ajax({
          url: '/workspace/manager/portal/student/info/elective',
          method: 'post',
          data: this.$qs.stringify({
            studentId: this.studentId,
            courseId: this.score.courseId
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.electives = response.data['electives'] || []
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../styles/color";
  .student-course-performance-detail {
    & > .score-wrap {
      .value {
        color: #303133;
        font-weight: bold;
        &.is-fail {
          color: $set-danger-color;
        }
      }
      .holder {
        cursor: pointer;
      }
    }
  }
  .student-course-performance-detail-popper {
    .el-popover__title {
      font-size: 12px!important;
    }
    .detail-main {
      min-height: 72px;
      .vxe-table {
        .vxe-table--body-wrapper {
          .vxe-table--body {
            .vxe-body--row {
              .vxe-body--column {
                .vxe-cell {
                  .is-fail {
                    color: $set-danger-color;
                  }
                }
              }
            }
          }
        }
      }
      .layout-hint {
        height: 72px;
      }
    }
  }
</style>
